<template>
  <div class="service-type-page service-type-page--detail">

    <section class="service-type-page__header">
      <div class="service-type-page__header-icon">
        <i class="fas fa-tags" aria-hidden="true"></i>
      </div>
      <div>
        <span>KLASIFIKASI LAYANAN</span>
        <h1>Detail tipe layanan</h1>
        <p>Informasi kategori yang digunakan untuk mengelompokkan produk layanan klinik.</p>
      </div>
    </section>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card class="service-type-page__card" :title="'Informasi tipe layanan'">
          <template v-slot:body>
            <div class="row align-items-center">

              <!-- Profile Image -->
              <div class="col-md-4 service-type-page__visual-column">
                <div class="d-flex justify-content-center align-items-center image-container service-type-page__visual">
                  <div class="service-type-page__visual-frame">
                    <img
                      class="image"
                      src="/images/expense-splash.svg"
                      @load="onImageLoad()"
                    >
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div
                class="col service-type-page__information"
                v-if="imgLoaded"
              >
                <table class="table mb-3 service-type-page__detail-table">
                  <tr>
                    <td style="width: 25%"><strong>Nama</strong></td>
                    <td>{{ data.name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Deskripsi</strong></td>
                    <td>{{ data.description }}</td>
                  </tr>
                </table>

                <div class="service-type-page__actions">
                <button
                  @click="$router.push({path: '/masters/payment-category-types/Edit/' + data.id})"
                  class="btn mx-1 btn-success"
                  v-if="btn && !data.is_system"
                ><i class="far fa-fw fa-edit"></i> Edit</button>
                <button
                  @click="deleteData"
                  class="btn mx-1 btn-danger"
                  v-if="btn && !data.is_system"
                ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
                </div>
              </div>

            </div>
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        name: "",
        descfription:"",
      },
      // Other
      imgLoaded: false,
      // user access
      btn: false,
    }
  },

  components: {
    Card,
  },

  methods: {

    onImageLoad() {
      this.imgLoaded = true
    },

    async deleteData() {
      let result = await module.delete('payment-category-types/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/masters/payment-category-types/list')
      }
    },

    async get() {
      this.data = await module.get('payment-category-types/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/masters/payment-category-types/list')
      }
    },

    setActiveButton(){
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for(a = 0; a < access_right.length; a++){
        if(access_right[a] == "1802"){
          this.btn = true
        }
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Tipe Produk Layanan", route: "" },
      { title: "Daftar Tipe Produk Layanan", route: "/masters/payment-category-types/list" },
      { title: "Detail" },
    ])
    // Get Data
    this.get()
    this.setActiveButton()
  },
}

</script>
